import React from 'react';
import Button from 'components/buttons/Button';
import "./modal-message.scss";

export default function ModalMessage ( props ) {
	
	const { extra_classes, heading, message, closeHandler, button_text } = props;

	return (
		<div className={`modal modal-message ${ extra_classes || "" }`}>
			<div className="modal__body">
				<div className="modal__content">

					{ heading && <div className="modal__heading"> { heading } </div>}

					{ message &&
						<div className="modal__message has-scrollbar">
							{ message }
						</div>
					} 

					<div className="modal__buttons">
						<Button extra_classes="filled" onClick={ closeHandler }>
							{ button_text || "Ok"}
						</Button>
					</div>
				</div>
			</div>
		</div>	
	)
}
